"use client";
import React from "react";
import { useTheme } from "../../Components/ThemeContext";

const techStack = [
  { src: "/Images/python.png", label: "Python" },
  { src: "/Images/javascript.png", label: "JavaScript" },
  { src: "/Images/typescript.png", label: "TypeScript" },
  { src: "/Images/c.png", label: "C/C++" },
  { src: "/Images/dart.png", label: "Dart" },
  { src: "/Images/react.png", label: "React" },
  { src: "/Images/nextjs.png", label: "Next.js" },
  { src: "/Images/flutter.png", label: "Flutter" },
  { src: "/Images/tailwind.png", label: "Tailwind" },
  { src: "/Images/nodejs.png", label: "Node.js" },
  { src: "/Images/express.png", label: "Express" },
  { src: "/Images/fastapi.png", label: "FastAPI" },
  { src: "/Images/django.png", label: "Django" },
  { src: "/Images/mongodb.png", label: "MongoDB" },
  { src: "/Images/postgresql.png", label: "PostgreSQL" },
  { src: "/Images/firebase.png", label: "Firebase" },
  { src: "/Images/mysql.png", label: "MySQL" },
  { src: "/Images/arduino.png", label: "Arduino" },
  { src: "/Images/raspberrypi.png", label: "Raspberry Pi" },
  { src: "/Images/aws.png", label: "AWS" },
  { src: "/Images/gcp.png", label: "GCP" },
  { src: "/Images/vercel.png", label: "Vercel" },
  { src: "/Images/figma.png", label: "Figma" },
  { src: "/Images/adobexd.png", label: "Adobe XD" },
];

const lightGridStyle = {
  backgroundImage: `
    linear-gradient(rgba(74,222,128,0.07) 1px, transparent 1px),
    linear-gradient(90deg, rgba(74,222,128,0.07) 1px, transparent 1px)
  `,
  backgroundSize: "40px 40px",
};

const darkGridStyle = {
  backgroundImage: `
    linear-gradient(rgba(74,222,128,0.04) 1px, transparent 1px),
    linear-gradient(90deg, rgba(251,146,60,0.05) 1px, transparent 1px)
  `,
  backgroundSize: "40px 40px",
};

export default function TechnologiesSection() {
  const { isDark } = useTheme();

  const headingText  = isDark ? "text-white"     : "text-gray-900";
  const greenHeading = isDark ? "text-green-400" : "text-green-700";
  const descText     = isDark ? "text-gray-300"  : "text-gray-600";
  const labelColor   = isDark ? "text-gray-300"  : "text-gray-700";

  return (
    <section
      className={`relative w-full overflow-hidden pt-4 pb-16 px-4 sm:px-8 md:px-12 lg:px-20 transition-colors duration-300 ${
        isDark ? "bg-black text-white" : "bg-transparent text-gray-900"
      }`}
      style={isDark ? darkGridStyle : lightGridStyle}
    >
      <div className="relative z-10">
        {/* Heading */}
        <div className="text-center mb-10">
          <h2 className={`text-xl sm:text-2xl lg:text-3xl font-semibold ${headingText}`}>
            Technologies
          </h2>
          <h2 className={`text-2xl sm:text-3xl md:text-4xl font-bold ${greenHeading}`}>
            Technologies We Use
          </h2>
          <p className={`mt-3 text-sm md:text-base ${descText}`}>
            We leverage modern tools and technologies to build scalable, high-performance solutions.
          </p>
        </div>

        {/* Marquee */}
        <div className="relative overflow-hidden w-full">
          {/* Fade edges */}
          <div className="pointer-events-none absolute left-0 top-0 h-full w-16 z-10"
            style={{ background: isDark ? "linear-gradient(to right, #000, transparent)" : "linear-gradient(to right, #f0f4f0, transparent)" }}
          />
          <div className="pointer-events-none absolute right-0 top-0 h-full w-16 z-10"
            style={{ background: isDark ? "linear-gradient(to left, #000, transparent)" : "linear-gradient(to left, #f0f4f0, transparent)" }}
          />

          <div className="flex gap-12 animate-marquee w-max items-center">
            {[...techStack, ...techStack].map(({ src, label }, index) => (
              <div
                key={index}
                className="flex flex-col items-center justify-center flex-shrink-0"
              >
                <img
                  src={src}
                  alt={label}
                  className="w-16 h-16 sm:w-18 sm:h-18 md:w-20 md:h-20 object-contain transition-transform duration-300 hover:scale-110"
                />
                <span className={`mt-2 text-xs sm:text-sm font-medium ${labelColor}`}>
                  {label}
                </span>
              </div>
            ))}
          </div>
        </div>
      </div>

      {/* Slower animation */}
      <style jsx>{`
        .animate-marquee {
          animation: marquee 60s linear infinite; /* 🔥 slower (was 30s) */
        }
        .animate-marquee:hover {
          animation-play-state: paused;
        }
        @keyframes marquee {
          0%   { transform: translateX(0%); }
          100% { transform: translateX(-50%); }
        }
      `}</style>
    </section>
  );
}